import Footer from "../Footer";
import catalyst from "../Sage_logo_catalyst.svg";
import DisabledTenant from "./DisabledTenant";

const DisabledTenantWithWrapper = (): JSX.Element => {
  return (
    <div className="App t-catalyst">
      <a
        className="visually-hidden u-sr-only--focusable c-skip-link"
        href="#main-content"
      >
        Skip to content
      </a>
      <header className="c-banner">
        <div className="wrapper c-banner__inner discovery-hover-underline">
          <img
            src={catalyst}
            width="300"
            height="48"
            alt=""
            className="o-brand"
          />
          <h1 className="visually-hidden">Sage Catalyst</h1>
        </div>
      </header>
      <main id="main-content" className="d-flex flex-grow-1 mt-5">
        <DisabledTenant />
      </main>
      <Footer />
    </div>
  );
};

export default DisabledTenantWithWrapper;
